import { Component } from 'preact'
import Icon from '../assets'
import BigCard from '../community-category/assets/BigCard'
import SmallCard from '../community-category/assets/SmallCard'
import Radio, { RadioGroup } from '../design-system-components/radio'
import ConfigurationSectionLabel from '@insided/destination/modules/Customization/configurator/ConfigurationSectionLabel'

interface KnowledgeBaseWidgetConfigProps {
  content: Content
  onChange: (state: {selectedTemplate: number, displayOnlyParent: boolean}) => void
}

interface Content {
  selectedTemplate: number
  displayOnlyParent: boolean
}

interface State {
  selectedTemplateOption: number
  displayOnlyParent: boolean
}

class KnowledgeBaseConfigurator extends Component<KnowledgeBaseWidgetConfigProps, State> {
  constructor (props: KnowledgeBaseWidgetConfigProps) {
    super(props)
    this.state = {
      selectedTemplateOption: props.content.selectedTemplate,
      displayOnlyParent: props.content.displayOnlyParent
    }

    this.onChangeTemplate = this.onChangeTemplate.bind(this)
    this.onChangeDisplayChildrenProperty = this.onChangeDisplayChildrenProperty.bind(this)
    this.onChangeSend = this.onChangeSend.bind(this)
  }

  templateOptions = [{
    visual: <BigCard />,
    text: 'Big category card'
  }, {
    visual: <SmallCard />,
    text: 'Small category card'
  }]

  onChangeTemplate (idx: number) {
    this.setState({ selectedTemplateOption: idx }, this.onChangeSend)
  }

  onChangeDisplayChildrenProperty (displayOnlyParent: boolean) {
    this.setState({ displayOnlyParent: displayOnlyParent }, this.onChangeSend)
  }

  onChangeSend () {
    this.props.onChange({
      selectedTemplate: this.state.selectedTemplateOption,
      displayOnlyParent: this.state.displayOnlyParent
    })
  }

  render () {
    const { selectedTemplateOption, displayOnlyParent } = this.state
    return (
      <div>
        <ConfigurationSectionLabel title='Template' templateSection>
          <div className='widget-configurator_tab-template'>
            <div className='card-content-selector'>
              <RadioGroup spacing='L'>
                <Radio
                  id='only-parent' label='label' name='card-selector'
                  value={<div>
                    <b>Display only parent categories</b>
                    <p>Choose this if you have many parent categories.</p>
                  </div>}
                  isChecked={displayOnlyParent}
                  onClick={() => this.onChangeDisplayChildrenProperty(true)}
                />
                <Radio
                  id='parent-child' label='label 2' name='card-selector'
                  value={<div>
                    <b>Display child and parent categories</b>
                    <p>Choose this if you have fewer parent categories.</p>
                  </div>}
                  isChecked={!displayOnlyParent}
                  onClick={() => this.onChangeDisplayChildrenProperty(false)}
                />
              </RadioGroup>
            </div>
            <div className='card-styling-selector'>
              {
                this.templateOptions.map((option, id) => (
                  <div
                    key={id}
                    className={`widget-configurator_template-option ${(id === selectedTemplateOption) ? 'checked' : ''}`}
                    onClick={() => this.onChangeTemplate(id)}
                  >
                    {option.visual}
                    <div>{option.text}</div>
                    <Icon size={16} icon='checkbox' customClass='checkbox-icon' />
                  </div>
                ))
              }
            </div>
          </div>
        </ConfigurationSectionLabel>
      </div>
    )
  }
}

export default KnowledgeBaseConfigurator
